import useSWR from "swr";
import { reqGetHeadersFront } from "grandus-lib/utils";

import EnergyLabel from "components/product/detail/energyLabel/EnergyLabel";
import Parameters from "components/product/detail/parameters/Parameters";

import isEmpty from "lodash/isEmpty";
import get  from "lodash/get";

import styles from "components/product/detail/packageProducts/PackageProductDetail.module.scss";

const PackageProductDetail = ({ productPackage }) => {

    const { data : product, error } = useSWR(
        `/api/lib/v1/products/${get(productPackage, "product.urlTitle")}`,
        (url) =>
            fetch(url, {
            headers: reqGetHeadersFront(null),
            }).then((r) => r.json()),
        {
            revalidateOnMount: true,
        }
    );

    if(isEmpty(get(product, "detailedParameters"))){
        return null;
    }

  return (
    <>
        <br/>
        <div className={styles['packageProductDetail']}>
            <h3 className={styles['packageProductDetail__title']}>Parametre</h3>
            <Parameters product={product}/>
            <br/>
            <EnergyLabel
                labels={get(product, "labels")}
                parameters={get(product, "detailedParameters")}
            />
        </div>
    </>
  );
};

export default PackageProductDetail;


